<div class="flex-box tab-box">
  <ng-container *ngFor="let tab of tabs">
    <div class="tab" [class.active]="tab.current" (click)="tabClick($event)">{{tab.name}}</div>
  </ng-container>
</div>

<ng-container *ngComponentOutlet="currentTab"></ng-container>